import React from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import AccessControl from 'components/AccessControl';
import ActivityPerms from 'components/AccessControl/permissions.json';
import CanDeleteAllFormsInSelection from 'common/Forms/Helpers/DeleteFormsHelper';

const ActionSelect = ({ selectedItems, permissions, openAssignToUserModal, openDeleteFormModal, openEditFormReferenceModal }) => (
  <div className="action-select">
    <div className="panel-title-selected">
      <div className="dropdown dropdown-right">
        <button
          type="button"
          className="btn btn-link dropdown-toggle"
        >
          { selectedItems.length } items selected
          <span className="icon icon-caret" />
        </button>
        <ul className="menu">
          {CanDeleteAllFormsInSelection(selectedItems, permissions)
            && <li className="menu-item">
              <button
                type="button"
                className="btn btn-link"
                disabled={ selectedItems.length <= 0 }
                onClick={ () => openDeleteFormModal() }
              >
                Remove all
              </button>
            </li> }
          { AccessControl.hasPermission(permissions, [ActivityPerms.scannedEdit])
            && <li className="menu-item">
              <button
                type="button"
                className="btn btn-link"
                disabled={ selectedItems.length <= 0 }
                onClick={ () => openEditFormReferenceModal() }
              >
                Edit Form Reference
              </button>
            </li> }
          { AccessControl.hasPermission(permissions, [ActivityPerms.fwfReassignToUser], true)
            && <li className="menu-item">
              <button
                type="button"
                className="btn btn-link"
                disabled={ selectedItems.length <= 0 }
                onClick={ () => openAssignToUserModal(selectedItems) }
              >
                Assign to user/s
              </button>
            </li> }
        </ul>
      </div>
    </div>
  </div>
);

ActionSelect.propTypes = {
  selectedItems: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  permissions: PropTypes.arrayOf(PropTypes.string).isRequired,
  settings: PropTypes.shape({}).isRequired,
  openAssignToUserModal: PropTypes.func.isRequired,
  openDeleteFormModal: PropTypes.func.isRequired,
  openEditFormReferenceModal: PropTypes.func.isRequired
};

ActionSelect.defaultProps = {
};

const mapStateToProps = state => ({
  settings: state.auth.settings,
  permissions: state.auth.permissions
});
export const ConnectedActionSelect = connect(mapStateToProps)(ActionSelect);

export default ConnectedActionSelect;
